import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail-===",
  "use": "icon-detail-===-usage",
  "viewBox": "0 0 21 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 11\" id=\"icon-detail-===\"><defs><style>#icon-detail-=== .a{fill:#ccc;}</style></defs><g transform=\"translate(-540 -1157)\"><rect class=\"a\" width=\"21\" height=\"1\" transform=\"translate(540 1157)\" /><rect class=\"a\" width=\"21\" height=\"1\" transform=\"translate(540 1167)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/detail-===.svg
// module id = st5J
// module chunks = 62